import React from "react";

function InfoGridSection({ title, fields = [] }) {
  return (
    <div className="profile-section">
      <h3>{title}</h3>
      <div className="info-grid">
        {fields &&
          fields.map((field, key) => {
            return (
              <div key={key}>
                <strong>{field.name}: </strong> {field.value}
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default InfoGridSection;
